export default "__VITE_ASSET__Rp7QW5qz__"